export default {
  registration: {
    header: {
      // title: "",
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: '여기는 본 서비스의 이용을 의뢰하신 기업용 전용 등록 페이지입니다.',
      section_two: '연계된 패스 코드를 입력하여 진행해 주세요.',
      section_three: '패스 코드를 모르는 경우는 귀사에 본 서비스를 의뢰한 기업에 문의해 주세요.',
      passcode: '열람용 패스 코드',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: '입력 내용에 누락된 것이 있습니다.',
      unexpected_error: '예기치 못한 오류가 발생했습니다.',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: '담당자의 이메일 주소를 입력해 주세요.',
      email: '이메일 주소',
      email_placeholder: '이메일 주소를 입력해 주세요',
    },
    sent: {
      section_one: '입력하신 이메일 주소로 메일을 보냈습니다.',
      // section_two: "",
      section_three: '30분 후에도 메일이 도착하지 않는 경우는',
      section_four: '로 알려주세요.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: '입력하신 이메일 주소는 이미 아스에네/아스에네 ESG의 계정을 등록 완료했습니다.',
      section_two: '등록된 패스워드를 입력해 주세요.',
      password: '패스워드',
      password_placeholder: '암호를 입력하십시오',
      error_auth: '인증에 실패했습니다. 다시 로그인해 주세요.',
      error_linking: '인증에 실패했습니다. 다시 패스워드를 입력해 주세요.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: '귀사의 회사 정보와 담당자명 등을 입력해 주세요.',
      section_three: '신청 후에 등록 완료한 계정으로 로그인하시면 의뢰하신 조사표/서베이에 대한 응답이 가능해집니다.',
      // buyer_name: "",
      expires_date: '등록 페이지의 유효기한',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: '회사명',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: '※입력하신 이메일 주소가 표시되어 있습니다',
      // phone: "",
      phone_placeholder: '0000000000',
      locale: '언어 선택',
      // section_one: "",
      rule: '이용약관',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ',',
      policy: ' 개인정보보호방침',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: '에 동의한 후에 진행해 주세요.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: '신청해 주셔서 감사합니다.',
      section_two: '입력하신 이메일 주소로 로그인 ID와 패스워드를 보냈습니다.',
      section_three: '메일을 확인하신 후 메일 내용에 따라 로그인해 주세요.',
      section_four: '30분 후에도 메일이 도착하지 않는 경우는',
      // section_five: "",
      // section_six: "",
    },
    expired: {
      section_one: '지정한 URL은 이미 유효기한이 지났습니다.',
      section_two: '이용을 원하는 경우는',
      section_three: '으로 알려주세요. 담당자가 다시 연락드리겠습니다.',
    },
    error: {
      section_one: '지정한 URL을 찾을 수 없습니다.',
      section_two: '번거로우시더라도 다시 URL을 확인해 주세요.',
    },
    btn: {
      submit: '송신하기',
      service_top: '서비스 톱',
      // login: "",
      register: '등록',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
